import { Alert, AlertRecordWithDate, AlertType } from 'lib/alert/models';
import React from 'react';
import FixedThresholdValueNoDimension from './FixedThreshold/FixedThresholdValueNoDimension';
import FixedThresholdValueWithDimension from './FixedThreshold/FixedThresholdValueWithDimension';

type GenericAlertValueProps = {
    alert: Alert;
    records: AlertRecordWithDate[];
    hasDimension: boolean;
};
const GenericAlertValue = ({
    alert,
    records,
    hasDimension,
}: GenericAlertValueProps) => {
    if (alert.type === AlertType.FIXED_THRESHOLD_CONDITION) {
        if (hasDimension) {
            return (
                <FixedThresholdValueWithDimension
                    alert={alert}
                    records={records}
                />
            );
        }
        return (
            <FixedThresholdValueNoDimension
                alert={alert}
                recordValues={records[0].values}
            />
        );
    }
    return <></>;
};

export default GenericAlertValue;
